import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  imgUrl: "",
  loading: false,
  newImageSrc: false,
  imgUrlArr: [],
};

const uploadStart = (state, action) => {
  return updateObject(state, { loading: true, imgUrl: "", newImageSrc: false });
};

const uploadSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    imgUrl: action.imgUrl,
    newImageSrc: true,
  });
};

const uploadFail = (state, action) => {
  return updateObject(state, { loading: false, imgUrl: "", newImageSrc: true });
};

const uploadMultyStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const uploadMultySuccess = (state, action) => {
  let oldArr = [...state.imgUrlArr];
  oldArr.push(action.imgUrl);
  return updateObject(state, {
    loading: false,
    imgUrlArr: oldArr,
  });
};

const uploadMultyFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteArr = (state, action) => {
  return updateObject(state, { imgUrlArr: [] });
};
const deleteArrIndex = (state, action) => {
  let newArr = state.imgUrlArr.filter((_, index) => index !== action.index);
  return updateObject(state, { imgUrlArr: [...newArr] });
};

const fillArrayOfImages = (state, action) => {
  return updateObject(state, { imgUrlArr: [...action.arr] });
};

const setInitialArr = (state, action) => {
  return updateObject(state, { imgUrlArr: [...action.arr] });
};

const clearArr = (state, action) => {
  return updateObject(state, { imgUrlArr: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.IMAGE_UPLOAD_START:
      return uploadStart(state, action);
    case actionTypes.IMAGE_UPLOAD_SUCCESS:
      return uploadSuccess(state, action);
    case actionTypes.IMAGE_UPLOAD_FAIL:
      return uploadFail(state, action);
    case actionTypes.IMAGE_MULTY_UPLOAD_START:
      return uploadMultyStart(state, action);
    case actionTypes.IMAGE_MULTY_UPLOAD_SUCCESS:
      return uploadMultySuccess(state, action);
    case actionTypes.IMAGE_MULTY_UPLOAD_FAIL:
      return uploadMultyFail(state, action);
    case actionTypes.IMAGE_DELETE_ARR:
      return deleteArr(state, action);
    case actionTypes.IMAGE_DELETE_ARR_INDEX:
      return deleteArrIndex(state, action);
    case actionTypes.IMAGE_FILL_ARRAY:
      return fillArrayOfImages(state, action);
    case actionTypes.IMAGE_SET_INITIAL_ARR:
      return setInitialArr(state, action);
    case actionTypes.IMAGE_CLEAR_ARR:
      return clearArr(state, action);
    default:
      return state;
  }
};

export default reducer;
